export default {
  // —— Console/Admin OpenAPI ——
  'pages.openapi.overview.title': 'Resumen de la plataforma abierta',
  'pages.openapi.overview.loadFailed': 'No se pudo cargar el resumen de uso (la API puede no estar lista)',
  'pages.openapi.overview.docsTitle': 'Guía de integración',
  'pages.openapi.overview.docsDesc':
    'BasePath de la plataforma abierta: /v1. Sobre de respuesta: {code,message,data,request_id}. Para API Keys envíe Authorization: Bearer sk_live_... / sk_test_.... La clave en texto plano solo se muestra una vez al crear o rotar; guárdela de forma segura.',
  'pages.openapi.overview.level': 'Nivel actual',
  'pages.openapi.overview.qps': 'Límite QPS',
  'pages.openapi.overview.apps': 'Apps',
  'pages.openapi.overview.appsSuffix': '(máx. {maxApps}, claves por app {maxKeys})',
  'pages.openapi.status.active': 'Activo',
  'pages.openapi.status.disabled': 'Desactivado',
  'pages.openapi.apps.title': 'Apps y claves',
  'pages.openapi.apps.listTitle': 'Mis apps',
  'pages.openapi.apps.create': 'Crear app',
  'pages.openapi.apps.createModal': 'Crear app',
  'pages.openapi.apps.name': 'Nombre de la app',
  'pages.openapi.apps.nameRequired': 'Introduzca un nombre',
  'pages.openapi.apps.description': 'Descripción',
  'pages.openapi.apps.status': 'Estado',
  'pages.openapi.apps.createdAt': 'Creado el',
  'pages.openapi.apps.createSuccess': 'App creada',
  'pages.openapi.apps.createFailed': 'Error al crear la app',
  'pages.openapi.apps.loadFailed': 'Error al cargar las apps',
  'pages.openapi.apps.keysLoadFailed': 'Error al cargar las claves',
  'pages.openapi.apps.delete': 'Eliminar',
  'pages.openapi.apps.deleteConfirm': '¿Eliminar esta app?',
  'pages.openapi.apps.deleted': 'Eliminada',
  'pages.openapi.apps.createKey': 'Crear Key',
  'pages.openapi.apps.createKeyModal': 'Crear API Key',
  'pages.openapi.apps.keyCreateSuccess': 'Clave creada',
  'pages.openapi.apps.keyCreateFailed': 'Error al crear la clave',
  'pages.openapi.apps.noPlainKey': 'No se devolvió la clave en texto plano',
  'pages.openapi.apps.plainKeyTitle': 'Guarde su API Key',
  'pages.openapi.apps.plainKeyHint': 'El texto plano solo se muestra una vez y no podrá verse de nuevo tras cerrar.',
  'pages.openapi.apps.copy': 'Copiar',
  'pages.openapi.apps.copied': 'Copiado',
  'pages.openapi.apps.copyFailed': 'Error al copiar; selecciónelo manualmente',
  'pages.openapi.apps.close': 'Cerrar',
  'pages.openapi.apps.key.name': 'Nombre',
  'pages.openapi.apps.key.namePlaceholder': 'Clave principal de producción',
  'pages.openapi.apps.key.prefix': 'Prefijo',
  'pages.openapi.apps.key.env': 'Entorno',
  'pages.openapi.apps.key.status': 'Estado',
  'pages.openapi.apps.key.createdAt': 'Creado el',
  'pages.openapi.apps.key.disable': 'Desactivar',
  'pages.openapi.apps.key.disableConfirm': '¿Desactivar esta clave?',
  'pages.openapi.apps.key.disabled': 'Desactivada',
  'pages.openapi.apps.key.enable': 'Activar',
  'pages.openapi.apps.key.enabled': 'Activada',
  'pages.openapi.apps.key.rotate': 'Rotar',
  'pages.openapi.apps.key.rotateConfirm': 'La rotación genera una nueva clave y devuelve el texto plano una sola vez. ¿Continuar?',
  'pages.openapi.apps.key.rotated': 'Rotada',
  'pages.openapi.apps.key.delete': 'Eliminar',
  'pages.openapi.apps.key.deleteConfirm': '¿Eliminar esta clave? No se puede deshacer.',
  'pages.openapi.apps.key.deleted': 'Eliminada',
  'pages.openapi.logs.title': 'Registros de uso',
  'pages.openapi.logs.listTitle': 'Detalles de llamadas',
  'pages.openapi.logs.dailyTitle': 'Uso de los últimos 14 días',
  'pages.openapi.logs.dailyEmpty': 'Sin datos de uso diario',
  'pages.openapi.logs.date': 'Fecha',
  'pages.openapi.logs.count': 'Llamadas',
  'pages.openapi.logs.createdAt': 'Hora',
  'pages.openapi.logs.requestId': 'Request ID',
  'pages.openapi.logs.requestIdPlaceholder': 'Pegue el request_id de la respuesta de la API',
  'pages.openapi.logs.detail': 'Detalles',
  'pages.openapi.logs.detailTitle': 'Detalles de la llamada',
  'pages.openapi.logs.detailLoading': 'Cargando…',
  'pages.openapi.logs.requestQuery': 'Query',
  'pages.openapi.logs.requestBody': 'Solicitud',
  'pages.openapi.logs.responseBody': 'Respuesta',
  'pages.openapi.logs.app': 'App',
  'pages.openapi.logs.appId': 'ID de app',
  'pages.openapi.logs.apiKey': 'API Key',
  'pages.openapi.logs.userId': 'ID de usuario',
  'pages.openapi.logs.apiKeyId': 'Key ID',
  'pages.openapi.logs.keyPrefix': 'Prefijo Key',
  'pages.openapi.logs.method': 'Método',
  'pages.openapi.logs.path': 'Ruta',
  'pages.openapi.logs.statusCode': 'HTTP',
  'pages.openapi.logs.code': 'Código de negocio',
  'pages.openapi.logs.latency': 'Latencia (ms)',
  'pages.openapi.logs.loadFailed': 'Error al cargar',
  'pages.openapi.planTiers.title': 'Planes de plataforma abierta',
  'pages.openapi.planTiers.level': 'Nivel',
  'pages.openapi.planTiers.levelTip':
    'Plan tier level (1–5), aligned with the user profile Level. Higher numbers mean higher tiers.',
  'pages.openapi.planTiers.name': 'Nombre',
  'pages.openapi.planTiers.qps': 'QPS',
  'pages.openapi.planTiers.qpsTip':
    'Max requests per second (Queries Per Second). Default rate limit for API Key calls on this tier: sustained rate equals this value; burst capacity is about QPS×2 (at least 5). Applies only to API Key calls; console/admin traffic is not counted. Individual keys may override. Exceeding the limit returns HTTP 429 (biz code 42901).',
  'pages.openapi.planTiers.dailyQuota': 'Cuota diaria',
  'pages.openapi.planTiers.dailyQuotaTip':
    'Max total API requests allowed per calendar day. Counted per user/key; only API Key calls count. Individual keys may override. Exceeding the limit returns HTTP 429 (biz code 42902).',
  'pages.openapi.planTiers.maxApps': 'Máx. apps',
  'pages.openapi.planTiers.maxAppsTip':
    'Maximum number of OpenAPI apps a developer on this tier can create.',
  'pages.openapi.planTiers.maxKeys': 'Máx. claves por app',
  'pages.openapi.planTiers.maxKeysTip': 'Maximum number of API keys allowed under each app.',
  'pages.openapi.planTiers.allowedScopes': 'Allowed permissions (scopes)',
  'pages.openapi.planTiers.allowedScopesTip':
    'API permission scopes this tier may request or be granted. App and API Key scopes must be a subset of this selection.',
  'pages.openapi.planTiers.save': 'Guardar',
  'pages.openapi.planTiers.saved': 'Guardado',
  'pages.openapi.planTiers.saveFailed': 'Error al guardar',
  'pages.openapi.planTiers.loadFailed': 'Error al cargar los planes',
  'pages.openapi.planTiers.readonly': 'Los observadores son de solo lectura y no pueden editar los planes',
  'pages.openapi.admin.usageLogsTitle': 'Auditoría de llamadas de plataforma abierta',
  'pages.openapi.admin.usageLogsList': 'Registros globales de llamadas',
  'pages.openapi.admin.disableKeyConfirm': '¿Desactivar esta API Key?',
  'pages.openapi.admin.disableKey': 'Desactivar Key',
  'pages.openapi.admin.keyDisabled': 'Desactivada',
  'pages.openapi.admin.appsTitle': 'Apps de plataforma abierta',
  'pages.openapi.admin.appsList': 'Todas las apps de desarrollador',
  'pages.openapi.admin.developers': 'Desarrolladores',
  'pages.openapi.admin.apps': 'Apps',
  'pages.openapi.admin.keys': 'Claves totales',
  'pages.openapi.admin.activeKeys': 'Claves activas',
  'pages.openapi.admin.todayRequests': 'Llamadas de hoy',
  'pages.openapi.admin.todayErrors': 'Errores de hoy',
  'pages.openapi.admin.errorCount': 'Errores',
  'pages.openapi.admin.owner': 'Propietario',
  'pages.openapi.admin.keyCount': 'Claves',
  'pages.openapi.admin.keyword': 'Palabra clave',
  'pages.openapi.admin.keywordPlaceholder': 'Nombre de app / descripción / código de inquilino',
  'pages.openapi.admin.statsLoadFailed': 'Error al cargar estadísticas',
  'pages.openapi.admin.noKeys': 'Sin claves',
  'pages.openapi.admin.appEnabled': 'App activada',
  'pages.openapi.admin.appDisabled': 'App desactivada',
  'pages.openapi.admin.appDisableConfirm': '¿Desactivar esta app?',
  'pages.openapi.admin.appEnableConfirm': '¿Activar esta app?',
  'pages.openapi.admin.keyEnableConfirm': '¿Activar esta clave?',
  'pages.admin.user.openapiDeveloperEnabled': 'Plataforma abierta',
  'pages.admin.user.openapi.on': 'Activado',
  'pages.admin.user.openapi.off': 'Desactivado',
  'pages.admin.user.openapiLevel': 'Nivel de plataforma abierta',
  'pages.admin.user.openapiDeveloperEnabled.label': 'Activar desarrollador',
  'pages.admin.user.openapiLevel.label': 'Nivel',
  'pages.admin.user.openapiLevel.placeholder': '1-5',
  'pages.openapi.overview.dailyUsage': 'Uso de hoy',
  'pages.openapi.apps.key.enableConfirm': '¿Activar esta clave?',
  'pages.admin.user.section.openapi': 'Plataforma abierta',
};
